const CLES_ERREUR = ['error', 'Error', 'message', 'Message', 'detail', 'Detail', 'title', 'Title', 'description', 'Description'];
const CLES_LISTE = ['errors', 'Errors', 'messages', 'Messages'];

/**
 * Rend lisible un message d'erreur CTRL (JSON `{"error":"..."}`, séquences `\u00E9`).
 * Idempotent si le texte est déjà une phrase.
 */
export function formaterErreurCtrl(message?: string | null): string {
    if (!message?.trim()) {
        return '';
    }
    let texte = message.trim();
    if (texte.startsWith('- ')) {
        texte = texte.slice(2).trim();
    }

    const debutObj = texte.indexOf('{');
    const debutArr = texte.indexOf('[');
    const debut =
        debutObj >= 0 && debutArr >= 0
            ? Math.min(debutObj, debutArr)
            : Math.max(debutObj, debutArr);
    if (debut < 0) {
        return decoderUnicode(texte);
    }

    for (let fin = texte.length; fin > debut + 1; fin--) {
        try {
            const extraite = extraireValeur(JSON.parse(texte.slice(debut, fin)));
            if (!extraite) {
                continue;
            }
            const prefixe = texte.slice(0, debut).trim().replace(/[.:\s]+$/, '');
            const suffixe = texte.slice(fin).trim();
            return [prefixe, extraite, suffixe].filter(Boolean).join(' : ');
        } catch {
            /* essayer un segment plus court */
        }
    }
    return decoderUnicode(texte);
}

function extraireValeur(valeur: unknown, profondeur = 0): string {
    if (profondeur > 5 || valeur == null) {
        return '';
    }
    if (typeof valeur === 'string') {
        const t = valeur.trim();
        if (t.startsWith('{') || t.startsWith('[') || t.includes('\\u')) {
            return formaterErreurCtrl(valeur);
        }
        return valeur;
    }
    if (Array.isArray(valeur)) {
        return valeur
            .map((x) => extraireValeur(x, profondeur + 1))
            .filter(Boolean)
            .join(' ');
    }
    if (typeof valeur === 'object') {
        const rec = valeur as Record<string, unknown>;
        for (const cle of CLES_ERREUR) {
            if (cle in rec) {
                const v = extraireValeur(rec[cle], profondeur + 1);
                if (v) {
                    return v;
                }
            }
        }
        for (const cle of CLES_LISTE) {
            if (cle in rec) {
                const v = extraireValeur(rec[cle], profondeur + 1);
                if (v) {
                    return v;
                }
            }
        }
    }
    return '';
}

function decoderUnicode(texte: string): string {
    if (!texte.includes('\\u')) {
        return texte;
    }
    return texte.replace(/\\u([0-9a-fA-F]{4})/g, (_, hex: string) =>
        String.fromCharCode(Number.parseInt(hex, 16)),
    );
}
